export default "__VITE_ASSET__BeftgNBg__"